import React, { useState } from "react"
import ReactPlayer from 'react-player/lazy'
import ImageModal from './ImageModal'

const InfoText = ({ title, content }) => {
    return (
        <div className="info-text">
            <p className="head">{title}</p>
            <div dangerouslySetInnerHTML={{ __html: content }} className="content"></div>
        </div>
    )
}

const PolicyTemplate = ({ data }) => {
    const { 
        twoColumns, 
        title, 
        headerContent, 
        policyText, 
        leftContentGroup, 
        rightContentGroup 
    } = data

    const [showImage, setShowImage] = useState(false);
    const [photo, setPhoto] = useState();

    const handleShowImageModal = (image, lightbox) => {
        if (lightbox) {
            setShowImage(!showImage);
            setPhoto(image)
        }
    }

    const hideImageModal = () => {
        setShowImage(false)
    }

    return (
        <>
            {twoColumns ? (
                <section className="two-columns">
                    <div className="col">
                        {leftContentGroup.video && (
                            <div className="media-wrapper">
                                <ReactPlayer 
                                    url={leftContentGroup.video}
                                    className='react-player'
                                    width='100%'
                                    height='100%'
                                    controls={true}
                                />
                            </div>
                        )}
                        <div className="content-wrapper">
                            {leftContentGroup.policyText ? leftContentGroup.policyText.map((text, index) => {
                                return (
                                    <InfoText 
                                        key={index}
                                        title={text.title}
                                        content={text.content}
                                    />
                                )
                            }) : null }
                        </div>
                    </div>
                    <div className="col">
                        <div className="content-wrapper">
                            {rightContentGroup.title && (
                                <h5>{rightContentGroup.title}</h5>
                            )}
                            {rightContentGroup.policyText ? rightContentGroup.policyText.map((text, index) => {
                                return (
                                    <InfoText 
                                        key={index}
                                        title={text.title}
                                        content={text.content}
                                    />
                                )
                            }) : null }
                        </div>
                        <div className="image-wrapper">
                            {rightContentGroup.image && (
                                <a onClick={(e) => handleShowImageModal(rightContentGroup.image, rightContentGroup.lightbox)}>
                                    <img 
                                        src={rightContentGroup.image?.localFile?.childImageSharp?.fluid.src}
                                    />
                                </a>
                            )}
                        </div>
                    </div>
                    <ImageModal showImage={showImage} hide={hideImageModal} photo={photo} />
                </section>
            ) :  (
                <section className="policy">
                    {title && (
                        <h5>{title}</h5>
                    )}
                    {headerContent && (
                        <div dangerouslySetInnerHTML={{ __html: headerContent }}></div>
                    )}
                    {policyText ? policyText.map((text, index) => {
                        return (
                            <InfoText 
                                key={index}
                                title={text.title}
                                content={text.content}
                            />
                        )
                    }) : null }
                </section>
            )
            }
        </>
    )
}

export default PolicyTemplate
